module.exports = __webpack_public_path__ + "media/images/icon__prize@2x-b573bf2c611b08cabe7f7dc0e75bffda.png";